import React from 'react';
import {Button} from 'reactstrap';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

export default function YesNoModal(props)
{
	const noToggle = () =>
	{
		if(props.hasOwnProperty('onNo'))
		{
			props.onNo();
		}
		props.toggle();
	};

	const yesToggle = () =>
	{
		if(props.hasOwnProperty('onYes'))
		{
			props.onYes();
		}
		props.toggle();
	};

	return (
		<Modal isOpen={props.isOpen} toggle={noToggle}>

			<ModalHeader toggle={noToggle}>
				{props.hasOwnProperty('title') && props.title}
			</ModalHeader>

			<ModalBody>
				{props.hasOwnProperty('body') && props.body}
			</ModalBody>

			<ModalFooter>
				<Button color='success' onClick = {yesToggle}>
					{props.hasOwnProperty('yesText') ? props.yesText : 'Yes'}
				</Button>
				<Button color='danger' onClick = {noToggle}>
					{props.hasOwnProperty('noText') ? props.noText : 'No'}
				</Button>
			</ModalFooter>
		</Modal>

	);
}
